// eslint-disable-next-line import/no-extraneous-dependencies
import { HardBreak } from '@tiptap/extension-hard-break';
import { mergeAttributes } from '@tiptap/core';
import Mention from '@tiptap/extension-mention';

// eslint-disable-next-line import/prefer-default-export
export const EmailInputBreakExtension = HardBreak.extend({
  addKeyboardShortcuts() {
    const isMentionSuggestionActive = () => {
      const { state } = this.editor;
      const pluginState = Mention.options.suggestion.pluginKey?.getState(state);

      return Boolean(pluginState?.active);
    };

    const isCursorAfterHardBreak = () => {
      const { selection } = this.editor.state;

      if (!selection.empty) {
        return false;
      }

      return selection.$from.nodeBefore?.type.name === this.name;
    };

    return {
      Enter: () => {
        if (isMentionSuggestionActive()) {
          return false;
        }

        if (isCursorAfterHardBreak()) {
          return this.editor.commands.splitBlock();
        }

        return this.editor.commands.setHardBreak();
      },
      'Shift-Enter': () => {
        if (isMentionSuggestionActive()) {
          return false;
        }

        return this.editor.commands.splitBlock();
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    return ['br', mergeAttributes(HTMLAttributes)];
  },
});
